import * as React from 'react'

import { UnreachableCaseError } from 'main/util/ts'
import { ICalloutOffset, Pin, PinType } from '../types'
import { CalloutContainer, MarkerContainer, PinContainer } from './Marker.styles'
import { GenericPin, WonderschoolPin } from './pins'
import { Priority } from './types'

interface ICallout {
  node: React.ReactNode
  offset: ICalloutOffset
}

interface IProps {
  lat: number
  lng: number
  callout: ICallout | null
  pin: Pin
  selected: boolean
  priority?: Priority
  onClick?: () => void
}

export default function Marker(props: IProps) {
  const { callout, pin, selected, priority, onClick } = props

  return (
    <MarkerContainer
      data-pendo={pendoTag()}
      selected={selected}
      priority={priority || Priority.DEFAULT}
      pin={pin}
    >
      <PinContainer onClick={handleClickPin}>{renderPin()}</PinContainer>
      {selected && callout && (
        <CalloutContainer offset={callout.offset}>{callout.node}</CalloutContainer>
      )}
    </MarkerContainer>
  )

  function renderPin() {
    switch (pin._type) {
      case PinType.Wonderschool:
        return <WonderschoolPin clickable={!!onClick} selected={selected} src={pin.src} />
      case PinType.Generic:
        return <GenericPin clickable={!!onClick} selected={selected} src={pin.src} />
      default:
        throw new UnreachableCaseError(pin)
    }
  }

  function handleClickPin(event: React.MouseEvent) {
    event.stopPropagation()
    if (onClick) {
      onClick()
    }
  }

  function pendoTag() {
    switch (pin._type) {
      case PinType.Wonderschool:
        return 'mapMarker-wonderschool'
      case PinType.Generic:
        return 'mapMarker-external_school'
      default:
        throw new UnreachableCaseError(pin)
    }
  }
}
